import React from 'react';
import HistoChart from '../components/HistoChart';
import TransactionsTable from '../components/TransactionsTable';
import CandlestickChart from '../components/CandleChart';
import { Helmet } from 'react-helmet';

const Transactions = ({ priceVolumeData, sellOrders, buyOrders, transactions }) => {

  return (
    <>
      <Helmet>
        <title>Transactions - Libra World from 0L Network</title>
        <meta name="description" content="View detailed transaction histories and analytics for the Libra token on the 0L Network. Monitor recent transactions, visualize transaction flow, candlestick chart, and gain insights into Libra’s trading activities." />
        <link rel="canonical" href={`https://libra-world.vercel.app/transactions`} />
      </Helmet>
      <div className="w-full pt-8 pb-8 text-gray-600">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Libra Transactions Analysis</h1>
        <h2 className="text-xl text-gray-600 max-w-lg mx-auto pb-12">Explore key 0Lswap transaction data and trends for the Libra token on the 0L Network.</h2>

        <HistoChart className="max-w-200px" priceVolumeData={priceVolumeData} sellOrders={sellOrders} buyOrders={buyOrders} />
        <TransactionsTable className="max-w-200px" transactions={transactions} sellOrders={sellOrders} buyOrders={buyOrders} />
        <CandlestickChart className="max-w-200px" completedOrders={transactions} />
      </div>
    </>
  );
}

export default Transactions;
